import { useContext, useRef } from "react";
import { OutboundConfigContext } from "./OutboundConfigContext";

/**
 * Custom hook which manages an extra ref variable and keeps it updated with current config.
 *
 * Use-case: To solve stale closures issue in useEffect without re-rendering on context updates.
 * ie. when we don't want to have dependency on outbound config context in useContext, but need
 * to use updated config inside it, in such cases we use configViewModelRef.
 *
 * @return {{outboundConfigModel, outboundConfigModelRef: React.MutableRefObject<*>, configDispatcher}}
 */
const useOutboundConfigContext = () => {
  const { outboundConfigModel, configDispatcher } = useContext(
    OutboundConfigContext,
  );
  const outboundConfigModelRef = useRef(outboundConfigModel);
  outboundConfigModelRef.current = outboundConfigModel;
  return {
    outboundConfigModel,
    configDispatcher,
    outboundConfigModelRef,
  };
};

export default useOutboundConfigContext;



// WEBPACK FOOTER //
// ./src/components/outboundAmzl/context/useOutboundConfigContext.js